module.exports = __webpack_public_path__ + "img/envelope-1.4f83bc4c.svg";